import React from "react";
import { Card, CardContent } from "./ui/card";
import { Star, ArrowRight } from "lucide-react";
import { mockData } from "../mock";
import Linkedin from "../assets/Images/linkedin.svg";
import { FaLinkedin } from "react-icons/fa6";

export const SocialProof = () => {
  return (
    <section id="social-proof" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl font-bold text-gray-900">
            Real Projects, Real Learning
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover insights from students who participated in real-world project initiatives at GJ Global
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="overflow-x-auto no-scrollbar">
          <div className="flex gap-6 pb-4">
            {mockData.testimonials.map((testimonial) => (
              <Card
                key={testimonial.id}
                className="bg-white flex flex-col justify-between gap-3 p-6 hover:shadow-lg transition-shadow duration-300 flex-shrink-0 max-w-[400px]"
              >
                <div className="space-y-3">
                  {/* Rating */}
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-4 h-4 fill-yellow-400 text-yellow-400"
                      />
                    ))}
                  </div>

                  {/* Testimonial */}
                  <blockquote className="text-gray-700 leading-relaxed text-sm">
                    "{testimonial.content}"
                  </blockquote>

                  {/* Badges */}
                  <div className="flex flex-wrap gap-2 text-xs">
                    <a
                      href={testimonial.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin className="size-6 text-blue-600" />
                    </a>
                  </div>
                </div>

                {/* Profile */}
                <div className="flex items-center gap-3 pt-4 border-t">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="font-semibold text-gray-900 text-sm flex items-center justify-between">
                      {testimonial.name}
                    </div>
                    <div className="text-xs text-gray-600">
                      {testimonial.role} at {testimonial.company}
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Company Logos */}
        <div className="text-center space-y-8 mt-20">
          <h3 className="text-2xl font-semibold text-gray-900">
            Learn Inside a Real-World Software Engineering Environment
          </h3>

          <div
            className={`grid gap-8 items-center justify-items-center ${
              mockData.technologyPartners.length === 1
                ? "grid-cols-1"
                : "grid-cols-2 md:grid-cols-5"
            }`}
          >
            {mockData.technologyPartners.map((partner, index) => (
              <div key={index}>
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-16 w-52 object-contain"
                />
              </div>
            ))}
          </div>

          <p className="text-gray-600 max-w-2xl mx-auto">
            Experience the tools, processes, and mentorship used by GJ Global to build scalable, production-grade software for global clients
          </p>
        </div>
      </div>
    </section>
  );
};
